"use client";

import useSWR, { preload } from "swr";

import { cn } from "@heroui/react";
import { useTranslations } from "next-intl";
import ReactQueryProvider from "@/components/ReactQueryProvider";

import { usePathname, useRouter } from "@/i18n/routing";
import { createClient } from "@/utils/supabase/client";

import { userMenuItems } from "@/config/site";
import Sidebar from "@/components/Sidebar";
import { HydraButton } from "@/components/HydraButton";
import { AnimatedCard } from "@/components/AnimatedCard";
import RustCrabIcon from "@/components/Icons/RustCrabIcon";
import { Footer } from "@/components/Footer";

const fetchUser = async () => {
  const supabase = createClient();
  try {
    const { data, error } = await supabase.auth.getSession();
    if (!error && data?.session) {
    } else if (error || error) {
      throw error || error;
    }
    return { session: data?.session, user: data?.session?.user };
  } catch (error) {
    console.log(error);
  }
};

// Preload the resource before rendering the User component below,
// this prevents potential waterfalls in your application.
// You can also start preloading when hovering the button or link, too.
preload("/api/user", fetchUser);

export default function JobsLayout({
  children,
  params,
}: {
  children: React.ReactNode;
  params;
}) {
  const t = useTranslations("User");
  const path = usePathname();
  const router = useRouter();

  const { data, error, isLoading } = useSWR(" ", fetchUser, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  async function handleSignIn() {
    router.push("/login");
  }

  return (
    <main>
      <section className={`min-h-screenNav w-full`}>
        <div
          className={`relative flex min-h-screenNav w-full max-w-[100vw] flex-grow flex-row-reverse md:flex-row`}
        >
          <div className="fixed right-[0rem] top-[4rem] z-[20] flex w-auto flex-row-reverse items-start justify-center md:sticky md:left-[0rem] md:h-screenNav md:w-auto md:flex-row">
            <Sidebar
              user={data?.user}
              isCompact={false}
              items={userMenuItems}
              defaultSelectedKey=""
              className={cn(
                "flew-grow mr-0 flex h-screenNav flex-col items-center justify-between bg-background p-4 shadow-lg backdrop-blur-lg transition-all md:ml-0 md:w-[15rem] md:bg-background-900/5 md:shadow-none",
              )}
            />
          </div>
          {data?.user ||
          path.includes("/user/jobs") ||
          path.includes("/user/bounties") ? (
            <div
              className={cn(
                "m-auto flex max-w-[1600px] flex-grow animate-fadeIn flex-col transition-all",
              )}
            >
              <ReactQueryProvider>{children}</ReactQueryProvider>
            </div>
          ) : (
            !isLoading && (
              <div
                className={cn(
                  "animate-fadeIno flex h-screenNav flex-grow flex-col items-center justify-center transition-all",
                )}
              >
                <AnimatedCard rotation={0} afterRotation={12} rotationHover={0}>
                  <div className="flex items-center justify-center rounded-2xl bg-[#6A478E]">
                    <RustCrabIcon className={"h-[12rem] w-[12rem]"} />
                  </div>
                  <h3 className="mb-[1rem]">{t("title")}</h3>
                  <HydraButton
                    color="secondary"
                    border="secondary"
                    aria-label="sign-in "
                    onClick={handleSignIn}
                  >
                    {t("cta")}
                  </HydraButton>
                </AnimatedCard>
              </div>
            )
          )}
        </div>
      </section>
      <Footer />
    </main>
  );
}
